export default __webpack_public_path__ + "static/media/img8.bbe452f8.PNG";